var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"left-content"},[_vm._v(" "+_vm._s(_vm.item.actionName)+" ")]),_c('div',{staticClass:"main-time"},[_c('div',{staticClass:"time-outer"},[_vm._v(" "+_vm._s(_vm.item.scores)+" ")])]),_c('div',{staticClass:"right-content"},[_vm._v(" "+_vm._s(_vm.item.actionName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }